import React from 'react'
import TaxPayerRow from './TaxPayerRow'

const TaxPayerTable = ({ taxpayerIds = [], total = 0, queryArgs }) => {
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="border-b border-slate-200 px-5 py-4">
        <h2 className="text-base font-semibold text-slate-800">
          Taxpayer Table
        </h2>
        <p className="text-sm text-slate-500">
          Showing {taxpayerIds.length} row{taxpayerIds.length !== 1 ? 's' : ''} from total {total}
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-slate-700">
          <thead className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">Taxpayer ID</th>
              <th className="px-4 py-3">Full Name</th>
              <th className="px-4 py-3">Nick Name</th>
              <th className="px-4 py-3">NPWP</th>
              <th className="px-4 py-3">NIK</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Phone</th>
              <th className="px-4 py-3">Nationality</th>
              <th className="px-4 py-3">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100">
            {taxpayerIds?.length ? (
              taxpayerIds.map((taxpayerId) => (
                <TaxPayerRow
                  key={taxpayerId}
                  taxpayerId={taxpayerId}
                  queryArgs={queryArgs}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="9"
                  className="px-4 py-6 text-center text-sm text-slate-500"
                >
                  No taxpayers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TaxPayerTable